import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(doLoadFreeTrialPromotion),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(loadSaga),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(watchSaga);

import { call, fork, takeEvery } from 'redux-saga/effects';
import { GET_CLASSPASS_DEFAULT_PROMOTION_ALIAS } from 'constants/promotions';
import { doLoadPromotionData } from 'components/CmsPage/modules/PlanSelection/plan-selection.saga';
import { getMsa } from 'containers/LocationModal/location.saga';
export var loadFreeTrialPromotion = function loadFreeTrialPromotion(msa) {
  return {
    type: 'FREE_TRIAL_LOAD_PROMOTION_DATA',
    msa: msa
  };
};
export function doLoadFreeTrialPromotion(client, _ref) {
  var msa;
  return regeneratorRuntime.wrap(function doLoadFreeTrialPromotion$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          msa = _ref.msa;
          _context.next = 3;
          return call(doLoadPromotionData, client, msa, GET_CLASSPASS_DEFAULT_PROMOTION_ALIAS);

        case 3:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
export function loadSaga(client) {
  var msa;
  return regeneratorRuntime.wrap(function loadSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return call(getMsa, client);

        case 2:
          msa = _context2.sent;
          _context2.next = 5;
          return call(doLoadFreeTrialPromotion, client, {
            msa: msa
          });

        case 5:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}
export function watchSaga(client) {
  return regeneratorRuntime.wrap(function watchSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return fork(takeEvery, loadFreeTrialPromotion().type, doLoadFreeTrialPromotion, client);

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}